export default __webpack_public_path__ + "static/media/banner.552c01a7.png";